var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gantt-label"},[_c('div',{staticClass:"gantt-label-content"},[_c('route-visibility',{attrs:{"routes":_vm.routes}}),_c('div',{staticClass:"upperFirst label-name"},[_vm._v(_vm._s(_vm._f("truncate")(_vm.name,33)))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }